export default function Footer() {
  return (
    <div
      style={{
        padding: "10px 20px 20px 20px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
      }}
    >
      <div>RAVISALPINE</div>
      <div>All rights reserved.</div>
    </div>
  );
}
